import React from "react";
import { Page, Text, View, Document, StyleSheet, Image, Link } from "@react-pdf/renderer";

import logo from "../../../images/logo.jpeg"
import phoneIcon from "../../../images/phone.jpeg";
import locationIcon from "../../../images/location.jpeg";
import emailIcon from "../../../images/mail.jpeg";

// Header Component - Updated with fixed positioning
const HeaderPDF = () => (
  <View style={headerStyles.container} fixed>
    <Image src={logo} style={headerStyles.logo} />
    <Text style={headerStyles.link}>sbsgroups.co.in</Text>
  </View>
);

// Footer Component - UPDATED with actual icons
const FooterPDF = () => (
  <View style={footerStyles.footer} fixed>
    {/* Red background */}
    <View style={footerStyles.background} />

    {/* Content with icons */}
    <View style={footerStyles.content}>
      <View style={footerStyles.row}>
        {/* Phone Column */}
        <View style={footerStyles.col}>
          <View style={footerStyles.iconContainer}>
            <Image src={phoneIcon} style={footerStyles.icon} />
            <Text style={footerStyles.label}>Phone:</Text>
          </View>
          <Text style={footerStyles.text}>8827559628</Text>
          <Text style={footerStyles.text}>9826808412</Text>
        </View>

        {/* Address Column */}
        <View style={footerStyles.col}>
          <View style={footerStyles.iconContainer}>
            <Image src={locationIcon} style={footerStyles.icon} />
            <Text style={footerStyles.label}>Address:</Text>
          </View>
          <Text style={footerStyles.text}>175 Shwetayan Industrial Park,</Text>
          <Text style={footerStyles.text}>Kathwada, Ahmedabad - 382430</Text>
        </View>

        {/* Email Column */}
        <View style={footerStyles.col}>
          <View style={footerStyles.iconContainer}>
            <Image src={emailIcon} style={footerStyles.icon} />
            <Text style={footerStyles.label}>Email:</Text>
          </View>
          <Text style={footerStyles.text}>info@sbsgroups.co.in</Text>
          <Text style={footerStyles.text}>sales@sbsgroups.co.in</Text>
        </View>
      </View>
    </View>
  </View>
);

// Terms and Conditions Component
const TermsAndConditions = () => (
  <View style={termsStyles.container} wrap={false}>
    <Text style={termsStyles.title}>Terms & Conditions</Text>

    <View style={termsStyles.list}>
      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Offer validity:</Text> 30 Days from the date of submission, thereafter it will be subject to confirmation by us.
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Prices:</Text> Quoted prices are Ex works. (our kathwada factory only)
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Taxes:</Text> 18% GST applicable
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>P&F:</Text> 2% of basic amount
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Transportation:</Text> Transportation charges will be in client scope, we are not responsible for Transportation damages (if transport arranged by Helix Engineers, so transportation charges will be paid 100% advance before dispatch.
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Transit Insurance</Text> to be borne by client.
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Payment Terms:</Text> 50% advance of total amount with GST along with PO, 50% of total amount against material readiness and Dispatch. (100% GST will be paid before dispatch)
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Delivery period:</Text> 10 to 12 weeks from PO date and advance Payment received & Drawing Approval.
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Installation:</Text> 3000/- Per Day, on-site civil work, Electric work, welding machine, drilling machine, hydra/ fork lift, soft labor required for installation of equipment will be in client scope.
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Overdue charges:</Text> overdue interest & warehousing charges, if your ordered goods are not lifted after one week of our material readiness, 2% (of order value) per week will be charged being overdue interest and warehousing charges.
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          Material unloading will be in client scope.
        </Text>
      </View>

      <View style={termsStyles.listItem}>
        <Text style={termsStyles.bullet}>•</Text>
        <Text style={termsStyles.text}>
          <Text style={termsStyles.bold}>Warranty:</Text>
        </Text>
      </View>

      <View style={[termsStyles.listItem, termsStyles.nestedItem]}>
        <Text style={termsStyles.bullet}>a)</Text>
        <Text style={termsStyles.text}>
          12 months from the date of invoice, we hereby warranty to replace free of cost Ex. Works kathwada, any component found defective due to any manufacturing defects only, bad workmanship will be not considered.
        </Text>
      </View>

      <View style={[termsStyles.listItem, termsStyles.nestedItem]}>
        <Text style={termsStyles.bullet}>b)</Text>
        <Text style={termsStyles.text}>
          warranty of bought out product will be remaining the same as per company terms.
        </Text>
      </View>

      <View style={[termsStyles.listItem, termsStyles.nestedItem]}>
        <Text style={termsStyles.bullet}>c)</Text>
        <Text style={termsStyles.text}>
          no warranty/Guarantee provided for electrical components (if any electrical failure occurs and due to this if any mechanical component fails than the same shall not cover any warranty/guarantee and the same will be supplied only on chargeable basis.
        </Text>
      </View>

      <View style={[termsStyles.listItem, termsStyles.nestedItem]}>
        <Text style={termsStyles.bullet}>d)</Text>
        <Text style={termsStyles.text}>
          In battery Operated Equipment battery charger will not cover in warranty, battery warranty will be 12 months.
        </Text>
      </View>
    </View>
  </View>
);

// Main PDF Component
const InvoicePDF = ({ data, leadInfo, quotationData,quotationNumber }) => (
  <Document>
    <Page size="A4" style={styles.page} wrap>
      {/* Header - Will appear on every page */}
      <HeaderPDF />

      {/* Main content */}
      <View style={styles.content}>
        {/* Company Info */}
        <View style={styles.header}>
          <Text style={styles.companyName}>SBS Company</Text>
          <Text>123 Business Street, Commercial Area</Text>
          <Text>Mumbai, Maharashtra , India - 400001</Text>
          <Text>Phone: +91-9876543210</Text>
          <Text>Email: contact@sbs.com</Text>
          <Text style={styles.title}>QUOTATION</Text>
          <Text>Quotation No: {quotationNumber}</Text>
          <Text>Date: {data.quotationDate}</Text>
        </View>

        {/* To Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>To:</Text>
          <Text>{leadInfo.lead_name}</Text>
          <Text>{leadInfo.email}</Text>
          <Text>{leadInfo.contact_number}</Text>
          <Text>Lead Source: {leadInfo.lead_source}</Text>
        </View>

        {/* Items Table */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            {/* <Text style={styles.tableColHeader}>Main Category</Text>
            <Text style={styles.tableColHeader}>Subcategory</Text> */}
            <Text style={styles.tableColHeader1}>Product</Text>
            {/* <Text style={styles.tableColHeader}>Batch</Text>
            <Text style={styles.tableColHeader}>Size</Text> */}
            <Text style={styles.tableColHeader}>HSN</Text>
            <Text style={styles.tableColHeader}>Quantity</Text>
            <Text style={styles.tableColHeader}>Unit Price</Text>
            <Text style={styles.tableColHeader}>GST %</Text>
            <Text style={styles.tableColHeader}>Total</Text>
          </View>

          {quotationData.map((item, index) => {
            const qty = parseInt(item.quantity) || 0;
            const price = parseFloat(item.listprice) || 0;
            const gstRate = parseFloat(item.gstrate) || 0;
            const total = qty * price + (qty * price * gstRate) / 100;

            return (
              <View
                style={[
                  styles.tableRow,
                  index % 2 === 0 ? styles.tableRowAlt : null,
                ]}
                key={item.id}
              >
                {/* <Text style={styles.tableCol}>{item.maincategory_name}</Text>
                <Text style={styles.tableCol}>{item.subcategory_name}</Text> */}
                <Text style={styles.tableCol1}>
  {item.maincategory_name} {"\n"}
  {item.subcategory_name} {"\n"}
  {item.product_name} - {item.batch} {"\n"}
  Size: {item.size}
</Text>

                {/* <Text style={styles.tableCol}>{item.batch}</Text>
                <Text style={styles.tableCol}>{item.size}</Text> */}
                <Text style={styles.tableCol}>{item.hsncode}</Text>
                <Text style={styles.tableCol}>{item.quantity}</Text>
                <Text style={styles.tableCol}>
                  {formatCurrency(item.listprice || 0)}
                </Text>
                <Text style={styles.tableCol}>{item.gstrate || 0}%</Text>
                <Text style={styles.tableCol}>{formatCurrency(total)}</Text>
              </View>
            );
          })}
        </View>

        {/* Summary */}
        <View style={styles.summary}>
          <View style={styles.summaryRow}>
            <Text style={styles.summaryLabel}>Subtotal:</Text>
            <Text style={styles.summaryValue}>
              {formatCurrency(data.subtotal)}
            </Text>
          </View>
          <View style={styles.summaryRow}>
            <Text style={styles.summaryLabel}>Tax ({data.tax}%):</Text>
            <Text style={styles.summaryValue}>
              {formatCurrency(data.totalGST)}
            </Text>
          </View>
          <View style={styles.summaryRow}>
            <Text style={styles.summaryLabel}>Shipping:</Text>
            <Text style={styles.summaryValue}>
              {formatCurrency(data.shipping)}
            </Text>
          </View>
          <View style={styles.summaryRow}>
            <Text style={[styles.summaryLabel, styles.boldText]}>
              Grand Total:
            </Text>
            <Text style={[styles.summaryValue, styles.boldText]}>
              {formatCurrency(data.grandTotal)}
            </Text>
          </View>
        </View>

        {/* Notes */}
        <View style={styles.notes}>
          <Text style={styles.boldText}>Notes:</Text>
          <Text>{data.notes}</Text>
        </View>
      </View>

      {/* Terms and Conditions on a new page */}
      <View break>
        <TermsAndConditions />
      </View>



      {/* Footer - Will appear on every page */}
      <FooterPDF />
    </Page>
  </Document>
);

// Currency formatter
const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);

// Styles
const headerStyles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 30,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 10,
    borderBottomWidth: 2,
    borderBottomColor: "#a00000",
  },
  logo: {
    width: 80,
    height: 80,
  },
  link: {
    fontSize: 14,
    color: "#a00000",
    fontWeight: "bold",
  },
});

const footerStyles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 0,
    right: 0,
    height: 110,
    zIndex: 1,
  },
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#c62828', // Red background
  },
  content: {
    position: 'relative',
    padding: 15,
    paddingTop: 10,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  col: {
    width: "30%",
  },
  iconContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  icon: {
    width: 40,
    height: 40,
    marginRight: 5,
  },
  label: {
    fontWeight: "bold",
    color: '#ffffff',
    fontSize: 9,
  },
  text: {
    color: '#ffffff',
    fontSize: 9,
    marginBottom: 2,
  },
});

const termsStyles = StyleSheet.create({
  container: {
    marginTop: 70,
    padding: 30,
    fontSize: 10,
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 15,
    textDecoration: "underline",
  },
  list: {
    marginLeft: 10,
  },
  listItem: {
    flexDirection: "row",
    marginBottom: 8,
  },
  nestedItem: {
    marginLeft: 20,
    marginBottom: 6,
  },
  bullet: {
    width: 15,
    fontWeight: "bold",
  },
  text: {
    flex: 1,
    textAlign: "justify",
  },
  bold: {
    fontWeight: "bold",
  },
});

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
    position: "relative",
    paddingBottom: 140, // Space for footer
    paddingTop: 100, // Space for header
  },
  content: {
    marginTop: 70, // Push content below the header
  },
  header: {
    textAlign: "center",
    marginBottom: 20
  },
  companyName: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 5,
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    marginTop: 12,
    marginBottom: 8,
    textDecoration: "underline",
  },
  section: {
    marginBottom: 15
  },
  sectionTitle: {
    fontWeight: "bold",
    marginBottom: 5
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 15,
  },
  tableRow: {
    flexDirection: "row"
  },
  tableColHeader1: {
    width: "40%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#f0f0f0",
    padding: 5,
    fontWeight: "bold",
    textAlign: "center",
    fontSize: 9,
  },
    tableColHeader: {
    width: "16.6%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#f0f0f0",
    padding: 5,
    fontWeight: "bold",
    textAlign: "center",
    fontSize: 9,
  },
  tableCol1: {
    width: "40%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    textAlign: "center",
    fontSize: 9,
  },
    tableCol: {
    width: "16.6%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    textAlign: "center",
    fontSize: 9,
  },
  summary: {
    marginBottom: 15,
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 4
  },
  summaryLabel: {
    width: "70%",
    textAlign: "right",
    paddingRight: 10
  },
  summaryValue: {
    width: "30%",
    textAlign: "right"
  },
  boldText: {
    fontWeight: "bold",
  },
  notes: {
    marginTop: 12,
    fontSize: 9,
    marginBottom: 20,
  },
});

export default InvoicePDF;